import PropTypes from 'prop-types';
import { responsiveSupportedSizes } from '../../Element/Element';

function StepperItem({ children }) {
  if (!children) {
    return null;
  }

  return children;
}

StepperItem.propTypes = {
  /** String, number or React component rendered inside the step component */
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.element,
  ]),
  /** String or element that is passed as the description to the respective Step component */
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** Control responsiveHidden prop of description container */
  descriptionResponsiveHidden: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({
      thinnerThan: PropTypes.oneOf(responsiveSupportedSizes),
      widerThan: PropTypes.oneOf(responsiveSupportedSizes),
      at: PropTypes.oneOf(responsiveSupportedSizes),
    }),
  ]),
  /** Pile description and step icon vertically */
  stepContentToColumn: PropTypes.bool,
  /** Any number of elements that are rendered when the item is active */
  children: PropTypes.any,
};

export default StepperItem;
